/* eslint-disable react/no-unescaped-entities */
import { Tooltip } from '@mui/material'
import Avatar from '@mui/material/Avatar'
import { memo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useDateStore } from '../../contexts/DateStore'
import { useSocketStore } from '../../contexts/SocketStore'
import { useUsersStore } from '../../contexts/UsersStore'
import { ROOM_PREFIX_DAY_EDIT, ROOM_PREFIX_WEEK_EDIT } from '../../utils/constantes'
import './UsersConnected.css'

const UsersConnectedDayView = memo(() => {
  const { userListByPrefix } = useSocketStore(
    useShallow((state) => ({
      userListByPrefix: state.userListByPrefix,
    }))
  )
  const { date, monday } = useDateStore(
    useShallow((state) => ({
      date: state.date,
      monday: state.monday,
    }))
  )

  const users = useUsersStore(useShallow((s) => s.users))

  const renderUser = ({ userId }, index, isSmall) => {
    const user = users[userId]
    return (
      <Tooltip
        key={userId + index}
        title={`${user?.first_name} ${user?.name}`}
        placement="top-start"
        arrow
      >
        <div>
          <Avatar
            className={`avatar-circle ${isSmall ? 'small-avatar' : ''}`}
            sx={{
              bgcolor: user?.color,
              color: 'black',
              marginLeft: `${index * 2}rem`,
              zIndex: 100 - index,
            }}
            alt={user?.initials}
          >
            {user?.initials}
          </Avatar>
        </div>
      </Tooltip>
    )
  }
  const usersWithEditOnDay = [
    ...(userListByPrefix[ROOM_PREFIX_DAY_EDIT][date?.toISOString()] || []),
    ...(userListByPrefix[ROOM_PREFIX_WEEK_EDIT][monday?.toISOString()] || []),
  ]
  return (
    <div className="avatars marginTop">
      <div className="userText">Éditeurs en ligne</div>
      <div className="userOnWeekAndButton">
        <div className="avatar-group">
          {usersWithEditOnDay.map((u, index) => renderUser(u, index, true))}
        </div>
      </div>
    </div>
  )
})
export default UsersConnectedDayView
